export var guid = function guid() {
  var tempUrl = URL.createObjectURL(new Blob());
  var tuuid = tempUrl.toString();
  URL.revokeObjectURL(tempUrl);
  return tuuid.substring(tuuid.lastIndexOf('/') + 1);
};